import { Component, inject } from "@angular/core";
import { createStockTypeConfig } from "../../configs/create-stock-type.config";
import { StockTypeFormComponent } from "../../components/stock-type-form/stock-type-form.component";
import { PageHeaderComponent } from "@app/shared-core/components/page-header/page-header.component";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { Router } from "@angular/router";
import { StockTypeForm } from "../../models/stock-type-form.model";
import { BreadCrumbComponent } from "@kernel/tools/bread-crumb/components/bread-crumb/bread-crumb.component";
import { createBreadCrumb } from "@app/applications/stock/domains/stock-type/configs/bread-crumb-stock-type.config";
import { StockTypeRoutePaths } from "@app/applications/stock/domains/stock-type/stock-type-route-paths";
import { PageTitleService } from "@app/shared/general/services";

@Component({
  selector: "app-create-stock-type",
  imports: [StockTypeFormComponent, PageHeaderComponent, SxwFormComponent, BreadCrumbComponent],
  templateUrl: "./create-stock-type.component.html",
  styleUrl: "./create-stock-type.component.scss",
  providers: [StockTypeForm],
})
export class CreateStockTypeComponent {
  /**
   * Injecting the Angular Router for navigation
   * @private
   */
  private router = inject(Router);

  /**
   * Page title service for clean title management
   */
  pageTitle = inject(PageTitleService);

  /**
   * Injecting the StockTypeForm model for managing form state
   */
  readonly formModel = inject(StockTypeForm);

  /**
   * Configuration for the mutation operation
   */
  mutationConfigType = createStockTypeConfig();

  breadCrumb = createBreadCrumb;

  constructor() {
    this.pageTitle.setupTitle("STOCK_TYPE.TITLES.CREATE");
  }

  /**
   * Method to navigate back to the stock type list page
   */
  async navigateToList() {
    await this.router.navigate([StockTypeRoutePaths.ROOT]);
  }

  protected readonly StockTypeRoutePaths = StockTypeRoutePaths;
}
